// extracted by mini-css-extract-plugin
export default {"hiddenInput":"fileButton__hiddenInput-vOCHO"};